export const MSGS = {
  BASIC_SETTING_UPDATE_SUCCESS: "Updated successfully",
};

export default MSGS;
